// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"CurrencyOption_icon-wrapper__VY1MT","supported-networks":"CurrencyOption_supported-networks__vuYuz"};